import React from "react";

const Cancellation = () => {
  return (
    <section id="h4-pricing" className="relative w-full overflow-hidden">
      <div className="w-full h4-pricing-wrapper pb-[6rem] md:pb-[8rem] max-md:pt-[120px] md:pt-[160px] pricing_section_bg">
        <div className="theme-container mx-auto">
          <div className="w-full">
            <div className="title-area w-full flex justify-center">
              <div className="flex flex-col items-center">
                <div className="py-0.5 px-5 bg-[#1D109E07] border-[#1D109E1e] border rounded-[30px] font-medium text-[#1D109E] mb-5">
                  <span>Cancellation Policy</span>
                </div>
                <div className="mb-[60px]">
                  <h2 className="text-main-black font-semibold text-24 sm:text-48 text-center max-w-[519px]">
                    Truvana OPD
                  </h2>
                </div>
              </div>
            </div>
            <div className="container">
              <div className="services-details-items">
                <div className="row">
                  <div className="col-xl-12 services-single-content">
                    <p>
                      We believes in helping its customers as far as possible,
                      and has therefore a liberal cancellation policy. Under
                      this policy:
                    </p>
                    <ul>
                      <li>
                        1. Cancellations will be considered only if the request
                        is made within 7 days of placing the order. However, the
                        cancellation request may not be entertained if the
                        orders have been communicated to the vendors/merchants
                        and they have initiated the process of shipping them.
                      </li>
                      <li>
                        2. We does not accept cancellation requests for orders
                        already initiated or in transit or completed. However,
                        refund/replacement can be made if the customer
                        establishes that the quality of product/service
                        delivered is not good.
                      </li>
                      <li>
                        3. In case of improper delivery of services or
                        inaccurate results, please report the same to our
                        Customer Service team. The request will, however, be
                        entertained once the health provider has checked and
                        determined the same at his own end. This should be
                        reported within 7 days of receipt of the
                        product/service.
                      </li>
                      <li>
                        4. In case you feel that the product/service received is
                        not as promised by us or as per your expectations, you
                        must bring it to the notice of our customer service
                        within 7 days of receiving the product/service. The
                        Customer Service Team after looking into your complaint
                        will take an appropriate decision.
                      </li>
                      <li>
                        5. In case of any Refunds approved by us, it’ll take 6-8
                        days for the refund to be processed to the end customer.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="shape-1 absolute left-40 top-96 z-10">
          <img src="assets/images/home-four/shape-1.webp" alt="" />
        </div>
        <div className="shape-2 absolute right-96 top-96 z-10">
          <img src="assets/images/home-four/shape-2.webp" alt="" />
        </div>
        <div className="shape-3 absolute left-96 top-[550px] z-10">
          <img src="assets/images/home-four/shape-3.webp" alt="" />
        </div>
        <div className="shape-4 absolute right-96 top-[550px] z-10">
          <img src="assets/images/home-four/shape-4.webp" alt="" />
        </div>
      </div>
    </section>
  );
};

export default Cancellation;
